// extracted by mini-css-extract-plugin
export var column = "ColumnsSection-module--column--b0b5b";
export var content = "ColumnsSection-module--content--2dedb";
export var row = "ColumnsSection-module--row--4514f";
export var wrapper = "ColumnsSection-module--wrapper--4d4cb";